import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@peacecover/component';
import { ArrowLeft } from '@peacecover/icon';
import { useGetBuddyPreferences } from '../../domains/findBuddy/ui/hooks/useGetBuddyPreferences';
import FanBuddyProfileCard from './components/FanBuddyProfileCard';
import GradientLoadingSpinner from '../components/GradientLoadingSpinner';
import ProfileAvatar from '../my-page/components/ProfileAvatar';
import CornerHolder from './components/CornerHolder';

const FanBuddySettingCompletePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: buddyPreferences, isLoading: isLoadingBuddyPreferences } = useGetBuddyPreferences();

  if (isLoadingBuddyPreferences) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <GradientLoadingSpinner size={36} />
      </div>
    );
  }

  if (!buddyPreferences) {
    return <div>No buddy preferences found</div>;
  }

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)]">
      <div className="px-[16px] py-[12px] flex items-center justify-between relative w-full">
        <button type="button" onClick={() => navigate('/home')}>
          <ArrowLeft size={24} className="text-text-main-lv1" />
        </button>
        <p className="text-text-main-lv1 text-[17px] font-bold leading-[20px] absolute left-[50%] translate-x-[-50%]">
          {t('FanBuddySetting.title')}
        </p>
        <ProfileAvatar thumbnailUrl={buddyPreferences?.thumbnailUrl} widthAndHeight="29px" />
      </div>
      <div className="flex flex-col items-center justify-center mt-[20px]">
        <div className="flex flex-col items-center gap-[14px] py-[10px]">
          <h1 className="text-[20px] font-semibold leading-[24px] text-text-main-lv1">
            {t('FanBuddySettingComplete.title')}
          </h1>
          <p className="text-[15px] font-medium leading-[18px] text-text-main-lv4">
            {t('FanBuddySettingComplete.description')}
          </p>
        </div>
        <div className="mt-[37px] relative">
          <CornerHolder className="absolute top-[-21px] left-[-21px] z-[10]" />
          <CornerHolder className="absolute bottom-[-21px] right-[-21px] z-[10] rotate-180" />
          <FanBuddyProfileCard size="small" buddyProfileCard={buddyPreferences} isMine={true} />
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(20px+env(safe-area-inset-bottom))] w-full flex flex-col gap-[20px] items-center z-10">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold"
          onClick={() => navigate('/fan-buddy/find', { replace: true })}
        >
          {t('FanBuddySettingComplete.start')}
        </Button>
        <button
          type="button"
          className="text-[13px] leading-[16px] text-text-main-lv2"
          onClick={() => navigate('/fan-buddy/intro')}
        >
          {t('FanBuddySettingComplete.recreateProfileCard')}
        </button>
      </div>
    </div>
  );
};

export default FanBuddySettingCompletePage;
